module.exports = __webpack_public_path__ + "static/img/10010 (1).1c72744.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10010 (1).webp
// module id = 2YTJ
// module chunks = 14